module.exports = __webpack_public_path__ + "img/img2.fe106983.png";